let head = 'http://localhost:3018/'
head = 'https://api.sz-huayida.cn/'
head = 'https://api.bimffawards.com/'
head = 'http://weidianying.wxdaiyan.cn/'
head = 'https://xschool.tju.edu.cn/api/'

// eslint-disable-next-line import/no-anonymous-default-export
export default head
